<template>
  <div>
    <headers :show="show"></headers>
    <div class="zong">
      <div class="zong1">
        <div class="zong1-title">绿萝分发团队版本包含那些功能</div>
        <div class="zong-time">发表时间：2020-100-17 02:20</div>
      </div>
      <div class="zong2">
        <div class="zong2-title">团队功能适合那些人？</div>
        <div class="zong2-item">
          团队功能只要面向管理、权限需求、多成员协作用户；
        </div>
        <p class="zong2-item2" style="margin: unset">
          团队版可以创建绿萝分发独立的子账号（员工账号），并对子账号分配各类自媒体账号、权限及监控，子账号之间彼此隔离，互不可见，都受主账号完全控制；子账号可享受团队管理功能外的所有基础功能，实现成员高效办公。
        </p>
        <div class="zong2-item3">
          <span class="item3-span"> 要注意：主子账号共享权限 </span>
          ，假设主账号拥有管理200个账号、20个子账号功能，那么主+子一共，只能管理200个，具体按照自行实际情况分配账号
        </div>
      </div>
      <div class="zong3">
        <div class="zong3-title">主账号可控制子账号的那些权限？</div>
        <div class="zong3-item">
          <div style="padding-top: 12px">
            目前可控制权限：分配账号、屏蔽收益、屏蔽数据、添加账号、员工监控5种功能
          </div>
          <div>
            <span>分配账号：</span
            >主账号可根据实际情况，给子账号分配对应的账号，子账号登录即可享受被分配的账号；
          </div>
          <div>
            <span>屏蔽收益：</span
            >如果不给此权限，子账号在易媒数据统计、网页后台收益页面，都做了屏蔽处理，均无法查看收益；
          </div>
          <div>
            <span>屏蔽账密：</span
            >如果不给此权限，子账号无法查看所分配的账号、密码，但软件能自动登录，不影响使用（主账号添加的时候，一定要用账密登录）；
          </div>
          <div>
            <span>屏蔽数据：</span
            >如果不给此权限，子账号无法使用工作台——数据统计功能；
          </div>
          <div style="width: 80%">
            <span>添加账号：</span
            >如果账号过多，可让子账号自行添加账号，子账号添加完后，主账号点击同步账号，即可一并管理，单子账号自行添加，会知道所管理自媒体账号的账号密码，如果对账号、收益登封权限屏蔽需求童虎，可自行添加，再分配；
          </div>
          <div>
            <span>员工监控：</span
            >主账号对子账号运营监控，统计子账号名下，所有账号周期内的推荐、阅读、播放、收益、详细内容数据等各项数据；支持多参数曲线图、数据报表导出excel。
          </div>
          <div class="imgg" @click="openVideo(config.publishingContent)">
            <img src="../assets/qx.png" alt="" />
          </div>
        </div>
      </div>
      <div class="zong4">
        <div class="zong4-title">子账号如何登录？</div>
        <div class="zong4-item" style="padding-bottom: 20px">
          在绿萝分发登录页面，选择主账号创建的子账号登录即可
        </div>
        <div class="zong4-item1" style="margin-bottom: 5px">
          建议专人管理专号，避免多人同时管理1个自媒体账号，否则容易出现互挤下线的情况
        </div>
        <div class="zong4-item2" style="margin-bottom: 5px">
          后续会持续更新团队功能，包括但不限于：删除、下架作品的权限屏蔽
        </div>
        <div class="zong4-item3">
          在VIP购买页面，团队会员的定价与个人会员不同，选择团队版VIP购买即可，如需开通请在客户端内——点击右上角你的账号，点击续费，有问题请联系客服
        </div>
        <div class="imgg">
          <img src="../assets/jpg/qx2.jpg" alt="" />
        </div>
      </div>
    </div>

    <!-- 弹窗 -->
    <div v-if="isVideoOpen" class="video-modal">
      <div class="video-content">
        <video controls autoplay muted>
          <source :src="currentVideo" type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <button @click="closeVideo">关闭</button>
      </div>
    </div>

    <footers></footers>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";
import footers from "../router/components/footer/footer.vue";
import headers from "../router/components/header/header.vue";

import { useConfigStore } from "@/store/index";
const config = useConfigStore();

const isVideoOpen = ref(false);
const currentVideo = ref("");

const show = ref(true);

const openVideo = (videoSrc) => {
  currentVideo.value = videoSrc;
  isVideoOpen.value = true;
};

const closeVideo = () => {
  isVideoOpen.value = false;
};

onMounted(() => {});

const { defineComponent } = require("vue");
defineComponent({
  name: "teamEdition",
});
</script>

<style lang="less" scoped>
.zong {
  width: 72%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
  // border: 1px solid red;

  .zong1 {
    padding-top: 60px;

    .zong1-title {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: bold;
      font-size: 32px;
      color: #333333;
      line-height: 38px;
      text-align: center;
      font-style: normal;
      text-transform: none;
      padding-bottom: 20px;
    }

    .zong-time {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 15px;
      color: #666666;
      line-height: 18px;
      text-align: center;
      font-style: normal;
      text-transform: none;
    }
  }

  .zong2 {
    padding-left: 180px;
    padding-top: 40px;

    .zong2-title {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 500;
      font-size: 24px;
      color: #333333;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      padding: 12px 0;
    }

    .zong2-item,
    .zong2-item1,
    .zong2-item2,
    .zong2-item3 {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      //line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    .zong2-item2 {
      width: 80%;
    }

    .zong2-item3 {
      padding-bottom: 40px;

      .item3-span {
        color: #ff6842;
      }
    }
  }

  .zong3 {
    padding-left: 184px;

    .zong3-title {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 500;
      font-size: 24px;
      color: #333333;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    .zong3-item {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 500;
      font-size: 14px;
      color: #666666;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      display: flex;
      flex-direction: column;
      gap: 17px;

      span {
        color: #6358ed;
      }
    }

    .imgg {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 20px;
      padding-right: 180px;

      img {
        width: 600px;
        height: 340px;
        background: #6358ed;
        border-radius: 12px 12px 12px 12px;
      }
    }
  }

  .zong4 {
    padding-right: 140px;
    padding-top: 40px;

    .zong4-title {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 500;
      font-size: 24px;
      color: #333333;
      line-height: 28px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      padding-bottom: 12px;
    }

    .zong4-item,
    .zong4-item1,
    .zong4-item2,
    .zong4-item3 {
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 14px;
      color: #666666;
      line-height: 16px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    .zong4-item1,
    .zong4-item2 {
      color: #ff6842;
    }

    .imgg {
      display: flex;
      justify-content: center;
      align-items: center;
      padding-top: 20px;
      padding-bottom: 40px;
      height: 550px;

      img {
        position: absolute;
        left: 20%;
        width: 1000px;
        height: 550px;
        border-radius: 0px 0px 0px 0px;
      }
    }
  }
}
</style>
